import { t } from '@dive/localization-js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import AlertModal from './AlertModal';

class ConfirmAlertModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            error: null
        };
    }

    deleteModel = () => {
        // set loading
        this.setState({
            isLoading: true
        });

        // do call
        this.props
            .onConfirm()
            .then(() => {
                // finished
                this.props.onFinished();
            })
            .catch(err => {
                // set error
                this.setState({
                    isLoading: false,
                    error: t('errors.something_went_wrong')
                });
            });
    };

    render() {
        return (
            <AlertModal
                title={this.props.title}
                description={this.props.description}
                alertType="dark"
                confirmButtonLabel={t('general.confirm')}
                onDismissClicked={this.props.onDismissClicked}
                onConfirmClicked={this.deleteModel}
                isLoading={this.state.isLoading}
                error={this.state.error}
            />
        );
    }
}

ConfirmAlertModal.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    onDismissClicked: PropTypes.func.isRequired,
    onFinished: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired
};

export default ConfirmAlertModal;
